import { SEO, FAQ } from "../../data/startPageContent";

const BASE_URL = "https://clinikit.co.il";
const PAGE_URL = `${BASE_URL}${SEO.path}`;

/** Build the three JSON-LD blocks (SoftwareApplication, FAQPage, BreadcrumbList). */
export const buildStartJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: SEO.appName,
    alternateName: "קליניקיט",
    url: PAGE_URL,
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Healthcare Practice Management Software",
    operatingSystem: "Web Browser",
    inLanguage: "he",
    description: SEO.description,
    availableOnDevice: ["Desktop", "Mobile", "Tablet"],
    isAccessibleForFree: true,
    featureList: [
      "יומן תורים עם כל האפשרויות – תצוגות, סדרות, חדרים, ריבוי מטפלים, סנכרון Google Calendar",
      "תזכורות ואישורי הגעה ב-WhatsApp עם גיבוי SMS",
      "קביעת תורים עצמאית מדף אישי עם אימות זהות",
      "תיק מטופל דיגיטלי וסיכומי טיפול עם AI",
      "דפי תשלום מאובטחים, סליקת כרטיסי אשראי וחשבוניות אוטומטיות",
      "טפסים, שאלונים וחתימה דיגיטלית מהנייד",
      "ניהול צוות, הרשאות ויומן פעילות",
      "אבטחת מידע ברמה רפואית – AES-256, Google Cloud, תואם משרד הבריאות",
      "תמיכה אישית אנושית ב-WhatsApp ועוזר AI 24/7",
    ],
    audience: {
      "@type": "Audience",
      audienceType:
        "מטפלים, קליניקות פרטיות, רופאים וסטודיו יופי (קוסמטיקה, גבות, ציפורניים, שיער) בישראל",
    },
    offers: [
      {
        "@type": "Offer",
        name: "30 יום ניסיון חינם",
        price: SEO.trialPrice,
        priceCurrency: "ILS",
      },
      {
        "@type": "Offer",
        name: "מסלול מקצועי",
        price: SEO.monthlyPrice,
        priceCurrency: "ILS",
      },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: SEO.ratingValue,
      ratingCount: SEO.ratingCount,
      bestRating: "5",
      worstRating: "1",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: SEO.breadcrumbHome, item: `${BASE_URL}/` },
      { "@type": "ListItem", position: 2, name: SEO.breadcrumbCurrent, item: PAGE_URL },
    ],
  },
];
